import CommonModal from "@/components/common/CommonModal";
import { Button } from "@/components/ui/button";
import { Upload, Loader2, FileSpreadsheet } from "lucide-react";

interface UploadSalaryHeadConfirmModalProps {
  show: boolean;
  fileName?: string;
  isUploading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const UploadSalaryHeadConfirmModal = ({
  show,
  fileName,
  isUploading,
  onClose,
  onConfirm,
}: UploadSalaryHeadConfirmModalProps) => (
  <CommonModal
    show={show}
    onClose={onClose}
    title=""
    className="sm:max-w-md w-full rounded-2xl p-0 overflow-hidden"
  >
    <div className="p-6 w-full max-w-full min-w-0">
      <div className="flex flex-col items-center text-center w-full max-w-full min-w-0">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50 mb-4 border border-emerald-100 shrink-0">
          <Upload className="text-emerald-600 w-7 h-7" />
        </div>
        <h2 className="text-lg font-bold text-gray-900 mb-1.5 font-heading">
          Confirm Salary Heads Upload
        </h2>
        <p className="text-xs text-gray-500 leading-relaxed max-w-sm mb-4">
          Are you sure you want to upload and apply salary head amounts from this template file?
        </p>

        <div className="w-full max-w-full min-w-0 bg-slate-50 p-3 rounded-xl border border-slate-200 text-left text-xs flex items-center gap-2.5 mb-6 overflow-hidden">
          <FileSpreadsheet className="w-5 h-5 text-emerald-600 shrink-0" />
          <div className="min-w-0 flex-1 overflow-hidden">
            <span className="text-slate-500 block text-[11px]">Selected File:</span>
            <p className="font-semibold text-slate-800 truncate overflow-hidden text-ellipsis whitespace-nowrap m-0 text-xs" title={fileName}>
              {fileName || "Salary_Template.xlsx"}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 w-full">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isUploading}
            className="flex-1 rounded-xl h-10 font-semibold text-xs cursor-pointer"
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={isUploading}
            className="flex-1 rounded-xl h-10 font-semibold text-xs bg-emerald-600 hover:bg-emerald-700 text-white flex items-center justify-center gap-2 cursor-pointer"
          >
            {isUploading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin text-white" />
                Uploading...
              </>
            ) : (
              "Confirm & Upload"
            )}
          </Button>
        </div>
      </div>
    </div>
  </CommonModal>
);

export default UploadSalaryHeadConfirmModal;
